// Per-engine display config for the super-admin engine monitoring pages.
// One source of truth so the generic cluster/drill-down templates can render
// any engine consistently. Keep this small — anything that needs a chart goes
// in `appCharts`; everything else (KPIs, doc links) is optional.

import { TOKENS } from "../design/tokens";

export const ENGINE_CONFIG = {
  PINGORA: {
    type: "PINGORA",
    displayName: "Pingora",
    slug: "pingora",
    description: "Reverse proxy + WAF data plane",
    monogramColor: TOKENS.primary, // indigo
    appCharts: [
      { key: "requests_rate", label: "Requests / sec", color: "#22c55e", unit: "/s" },
      { key: "in_flight", label: "In-flight requests", color: "#f59e0b", unit: "" },
    ],
  },
  BM_ENGINE: {
    type: "BM_ENGINE",
    displayName: "BM-Engine",
    slug: "bm",
    description: "Bot management engine",
    monogramColor: "#8b5cf6", // violet
    appCharts: [
      { key: "requests_rate", label: "Flows processed / sec", color: "#8b5cf6", unit: "/s" },
    ],
  },
  AD_ENGINE: {
    type: "AD_ENGINE",
    displayName: "AD-Engine",
    slug: "ad",
    description: "Anti-DDoS engine",
    monogramColor: "#ef4444", // red
    appCharts: [],
  },
};

export function getEngineConfig(type) {
  return ENGINE_CONFIG[type] || ENGINE_CONFIG.PINGORA;
}

export default ENGINE_CONFIG;
